import { useMutation } from '@apollo/client';
import { Button, Fields } from '@ets-global/b2c-website-ui';
import { Form, Formik } from 'formik';
import React, { useContext, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { UPDATE_NEWSLETTER_SUBSCRIPTION } from '../../../graphql/mutations/updateNewsletterSubscription';
import { USER } from '../../../graphql/queries';
import errorsHandler from '../../../helpers/errorsHandler';
import { useNotification } from '../../../hooks';
import useDataLayer from '../../../hooks/useDataLayer';
import { AuthContext } from '../../../store/Auth';
import AccountBlock from '../../Account/Block';
import FormikObserver from '../../FormikObserver';

const NewsletterSubscription = () => {
  const { t } = useTranslation();
  const { newNotification } = useNotification();
  const { user } = useContext(AuthContext);
  const { pushEventConfirmSubscriptionNewsletter } = useDataLayer();

  const [isFormUpdated, setFormUpdated] = useState(false);
  const [hasOptIn, setHasOptIn] = useState(user.hasOptIn);

  const [updateNewsletterSubscription] = useMutation(UPDATE_NEWSLETTER_SUBSCRIPTION, {
    refetchQueries: [{ query: USER }],
  });

  const onSubmit = async (data, actions) => {
    if (data.hasOptIn === '' || data.hasOptIn === hasOptIn) {
      actions.setSubmitting(false);

      return;
    }
    try {
      await updateNewsletterSubscription({
        variables: { hasOptIn: Boolean(data.hasOptIn) },
      });

      newNotification({
        content: data.hasOptIn
          ? t('user-account.newsletter-subscription.message.subscribe')
          : t('user-account.newsletter-subscription.message.unsubscribe'),
        type: 'success',
      });
      setHasOptIn(data.hasOptIn);
      setFormUpdated(false);
    } catch (error) {
      return errorsHandler({ error, actions, newNotification, t });
    }

    if (data.hasOptIn) {
      pushEventConfirmSubscriptionNewsletter(user.isB2B);
    }
    actions.setSubmitting(false);
  };

  return (
    <AccountBlock
      title={t('user-account.newsletter-subscription.title')}
      subtitle={t('user-account.newsletter-subscription.subtitle')}
    >
      <Formik
        initialValues={{ hasOptIn }}
        onSubmit={onSubmit}
        render={({ isSubmitting, values }) => (
          <Form className="newsletter-subscription__form">
            <Fields.FormikFastField
              id={'hasOptIn'}
              name={'hasOptIn'}
              component={Fields.CheckboxField}
              label={t('user-account.newsletter-subscription.form.label.hasOptIn')}
            />
            <Button
              disabled={!isFormUpdated}
              loading={isSubmitting}
              type="submit"
              className="account-infos__center-mobile"
            >
              <Trans>user-account.newsletter-subscription.form.label.save</Trans>
            </Button>
            <FormikObserver values={values} onChange={() => setFormUpdated(true)} />
          </Form>
        )}
      />
    </AccountBlock>
  );
};

export default NewsletterSubscription;
